import { combineReducers, createStore, applyMiddleware } from "redux";
import {
  useSelector,
  TypedUseSelectorHook,
  createDispatchHook,
} from "react-redux";
import thunk from "redux-thunk";

import { usuario, plano, cadastro, AssinaturaReducer } from "./reducers";

import ClienteReducer, { type ClienteReducerActions } from "./reducers/cliente";
import PlanosReducer, { type PlanosReducerActions } from "./reducers/planos";

const devTools =
  (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
  (window as any).__REDUX_DEVTOOLS_EXTENSION__();

const reducers = combineReducers({
  usuario,
  plano,
  cadastro,
  assinatura: AssinaturaReducer,
  cliente: ClienteReducer,
  planos: PlanosReducer,
});

const middlewares =
  process.env.NODE_ENV === "development" && devTools
    ? applyMiddleware(devTools, thunk)
    : applyMiddleware(thunk);

const store = createStore(reducers, middlewares);

export type AppRootState = ReturnType<typeof store.getState>;
export type AppReducerActions = ClienteReducerActions | PlanosReducerActions;

export const useAppSelector: TypedUseSelectorHook<AppRootState> = useSelector;
export const useAppDispatch = createDispatchHook<
  AppRootState,
  AppReducerActions
>();

export default store;
